import { createSlice } from '@reduxjs/toolkit';

import { CountriesState } from '../../types';

import { COUNTRIES_STATE } from '../../constants';

import { setAvoidedCountries } from './setAvoidedCountries';

const initialState: CountriesState = {
  avoidedCountries: {}
}

export const countriesSlice = createSlice({
  name: COUNTRIES_STATE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    setAvoidedCountries(builder);
  }
});

export const countriesActions = countriesSlice.actions;
export const countriesReducer = countriesSlice.reducer;
